angular
  .module('contrast.factory.application.scores', [])
  .factory('ApplicationScoresFactory', function ($http, UserService) {
    'ngInject'

    return {
      getTraceBreakdownBySeverity: function (id, environment) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + id + '/breakdown/trace/severity'
          ),
          { params: { environment: environment } }
        )
      },
      getTraceBreakdownByStatus: function (id, environment) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + id + '/breakdown/trace/status'
          ),
          { params: { environment: environment } }
        )
      },
      getTraceBreakdownByType: function (id, environment) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + id + '/breakdown/trace/rule'
          ),
          { params: { environment: environment } }
        )
      },

      getAttackBreakdownByType: function (id, environment) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + id + '/breakdown/attack/type'
          ),
          { params: { environment: environment } }
        )
      },
      getAttackBreakdownByStatus: function (id, environment) {
        return $http.get(
          UserService.buildAPIUrl(
            '/applications/' + id + '/breakdown/attack/status'
          ),
          { params: { environment: environment } }
        )
      }
    }
  })
